import React, { useEffect, useState, useRef } from "react";
import EventLogisticsList from "./EventLogisticsList";
import { getAllEvents,getEventLogisticEvents } from "../../../API/Events";
import { updateLogistics } from "../../../API/routine";
import { formatAMPM, formatDate } from "../../../utils/common";
import NoData from "../../../components/NoData";
import { toast } from "react-toastify";
import { Base_Url } from "../../../API/config";

const EventLogistics = () => {
  const [showEvents, setShowEvents] = useState(false);
  const [logisticsDetail, setLogisticsDetail] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [eventId, setEventId] = useState({ id: "", name: "" });
  const [showEventType, setShowEventType] = useState("upcoming");

  const eventSourceRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const isFetching = useRef(false);

  const fetchEventDetailsOnce = async () => {
    if (isFetching.current) return;
    isFetching.current = true;
    try {
      const res = await fetch(
        `${Base_Url}/api/event-details?event_id=${eventId?.id}&status=${showEventType === "upcoming" ? 0 : 1}&stream=1`
      );
      const result = await res.json();
      if (Array.isArray(result?.data)) {
        setLogisticsDetail(result.data); // ✅ Set only if it's an array
      } else {
        console.warn("Expected array from API, got:", result?.data);
        setLogisticsDetail([]); // Fallback to empty array
      }
    } catch (err) {
      console.error("Failed to fetch event details:", err);
    } finally {
      isFetching.current = false;
    }
  };

  const fetchRoutineDetail = async () => {
    if (eventSourceRef.current) {
      console.log("SSE already running");
      return;
    }
    const url = `${Base_Url}/api/event-details?event_id=${eventId?.id}&status=${showEventType === "upcoming" ? 0 : 1}&stream=1`;
    const eventSource = new EventSource(url);
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setLogisticsDetail((prev) => {
        const newData = JSON.stringify(data.data);
        const prevData = JSON.stringify(prev);
        return newData !== prevData ? data.data : prev;
      });
    };
    eventSource.onerror = (err) => {
      console.error('SSE Error:', err);
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
      restartSSEWithDelay(); // only restart if it fails
    };
    // Store the EventSource so we can close it later
    eventSourceRef.current = eventSource;
  };

  // Throttle SSE restart
  const restartSSEWithDelay = () => {
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
    }
    reconnectTimeoutRef.current = setTimeout(() => {
      console.log("Restarting SSE after delay");
      fetchRoutineDetail();
    }, 1000);
  };

  const eventData = async () => {
    // const data = await getAllEvents(0);
    const data = await getEventLogisticEvents();
    setEventList(data?.data?.events);
  };
  useEffect(() => {
    if (eventId?.id) {
      fetchRoutineDetail();
    }
    eventData();
    // Cleanup on component unmount
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
    };
  }, [eventId?.id, showEventType]);

  const handleLogisticsChange = async (data) => {
    try {
      const response = await updateLogistics(data);
      if (response?.status) {
        toast.success(response.message || "success !");
        // Optimistic update
        setLogisticsDetail((prev) => {
          if (!Array.isArray(prev.eventSchedule)) return prev;
          const updatedSchedule = prev.eventSchedule.map((item) =>
            item.id == data.id ? { ...item, ...data } : item
          );
          const updated = { ...prev, eventSchedule: updatedSchedule };
          return updated;
        });
        await fetchEventDetailsOnce();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.event_btn')) {
        setShowEvents(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    <div className="event_list_container">
      {/* <div className="event_logistic_header">
        <div className="event_header">
          <div className="title"></div>
          <div className="event_button">
            <button
              className="event_btn"
              onClick={() => setShowEvents(!showEvents)}
            >
              {eventId?.name ? eventId?.name : "Choose Event"}{" "}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  fill="#ffffff"
                  d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                />
              </svg>{" "}
            </button>
          </div>
        </div>
        {showEvents && (
          <div className="scroll_remove">
            <div className="choose_events_div">
              <p>Choose events </p>
              <ul>
                {eventList?.map((event) => {
                  return (
                    <li
                      onClick={(e) => {
                        setEventId({
                          ...eventId,
                          id: event?.id,
                          name: event?.event_title.charAt(0).toUpperCase() + event?.event_title.slice(1).toLowerCase(),
                        });
                        setShowEvents(!showEvents);
                      }}
                    >
                      {event?.event_title.charAt(0).toUpperCase() + event?.event_title.slice(1).toLowerCase()}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div> */}
      {/* <div className="event_list">
        <div className="event_logistics_event">
          <div className="event_details">
            <span>Event Name : </span>
            {logisticsDetail?.event_title ? logisticsDetail?.event_title.charAt(0).toUpperCase() + logisticsDetail?.event_title.slice(1).toLowerCase() : ""}
          </div>
          <div className="event_details">
            <span>Start Date : </span>
            {logisticsDetail?.event_date
              ? formatDate(logisticsDetail?.event_date)
              : ""}
          </div>
          <div className="event_details">
            <span>End Date : </span>
            {logisticsDetail?.event_end_date
              ? formatDate(logisticsDetail?.event_end_date)
              : ""}
          </div>
          <div className="event_details">
            <span>Time : </span>
            {logisticsDetail?.event_time_from
              ? formatAMPM(logisticsDetail?.event_time_from)
              : ""}
          </div>
          <div className="event_details">
            <span>Location : </span>
            {logisticsDetail?.event_location
              ? logisticsDetail?.event_location
              : ""}
          </div>
        </div>
      </div> */}
      <div className="event_logistics_header">
        <div className="title">Event Logistics</div>
        <div className="button_div">
          <div className="event_logistic_header">
            <div className="event_header">
              <div className="event_button">
                <button
                  className="event_btn"
                  onClick={() => setShowEvents(!showEvents)}
                >
                  {eventId?.name ? eventId?.name : "Choose Event"}{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      fill="#ffffff"
                      d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                    />
                  </svg>{" "}
                </button>
              </div>
            </div>
            {showEvents && (
              <div className="scroll_remove">
                <div className="choose_events_div">
                  <p>Choose events </p>
                  <ul>
                    {eventList?.map((event) => {
                      return (
                        <li
                          onClick={(e) => {
                            setEventId({
                              ...eventId,
                              id: event?.id,
                              name: event?.event_title.charAt(0).toUpperCase() + event?.event_title.slice(1).toLowerCase(),
                            });
                            setShowEvents(!showEvents);
                          }}
                        >
                          {event?.event_title.charAt(0).toUpperCase() + event?.event_title.slice(1).toLowerCase()}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}
          </div>
          <div className="event_button">
            <button
              className={`${showEventType === "upcoming" ? "event_btn_active" : "event_btn"
                }`}
              onClick={() => setShowEventType("upcoming")}
            >
              Upcoming
            </button>
          </div>
          <div className="event_button">
            <button
              className={`${showEventType === "completed" ? "event_btn_active" : "event_btn"
                }`}
              onClick={() => setShowEventType("completed")}
            >
              Completed
            </button>
          </div>
        </div>
      </div>
      <div className="event_logistics table_text_wrap">
        {logisticsDetail?.eventSchedule?.length > 0 ? (
          <EventLogisticsList
            logisticsDetails={logisticsDetail?.eventSchedule}
            handleLogisticsChange={handleLogisticsChange}
            eventId={eventId?.id}
            fetchRoutineDetail={fetchRoutineDetail}
            showEventType={showEventType == 'upcoming' ? 0 : 1}
          />
        ) : (
          <NoData title="There is no event logistics yet" />
        )}
      </div>
    </div>
  );
};
export default EventLogistics;
